import React from 'react';
import { PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts';
import { formatNumber } from '../../../../utils/validation';

type Props = {
    data: {
        name: string;
        value: number;
        fill?: string;
    }[];
    title: string;
};

const InvestmentDealType: React.FC<Props> = ({ data, title }) => {
    return (
        <div className="p-4 bg-white w-full">
            <p className="WorkSans-Semibold font-semibold text-sm text-[#152C52] text-left">{title}</p>
            <ResponsiveContainer width="100%" height={250}>
                <RadialBarChart
                    width={500}
                    height={250}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    barSize={10}
                    data={data}
                    startAngle={90}
                    endAngle={-200}
                >
                    <PolarAngleAxis domain={[0, 'auto']} type="number" angleAxisId={0} tick={false} />
                    <RadialBar
                        dataKey="value"
                        label={(props: any) => {
                            const { x, cx, cy, value, name, viewBox } = props;
                            const { outerRadius, innerRadius, startAngle } = viewBox;

                            const RADIAN = Math.PI / 180;
                            const radius = innerRadius + (outerRadius - innerRadius) * 1.2;
                            const z = cx + radius * Math.cos(-startAngle * RADIAN);
                            const y = cy + radius * Math.sin(-startAngle * RADIAN);
                            return (
                                <text x={z - 7} y={y + 6} fill="#000" textAnchor={'end'} dominantBaseline="central">
                                    <tspan x={x} dy="0em" className="text-[10px]" fill="#6D707B">
                                        {name}
                                    </tspan>
                                    <tspan
                                        x={x}
                                        dy="0em"
                                        className="text-[10px] font-bold"
                                        width={'100px'}
                                        fill="#152C52"
                                    >
                                        &nbsp;{formatNumber(value)}
                                    </tspan>
                                </text>
                            );
                        }}
                    />
                </RadialBarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default InvestmentDealType;
